import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=c0a28330&scoped=true&"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=c0a28330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a28330",
  null
  
)

export default component.exports